"use client";

import { Link, usePathname } from "@/i18n/navigation";

const baseCls =
    "flex-shrink-0 whitespace-nowrap rounded-md px-2 py-1.5 text-xs transition-colors hover:bg-accent hover:text-accent-foreground sm:px-3 sm:text-sm";

function isActive(pathname: string, href: string): boolean {
    if (href === "/") return pathname === "/";
    return pathname === href || pathname.startsWith(href + "/");
}

export default function NavLink({
    href,
    children,
    external,
}: {
    href: string;
    children: React.ReactNode;
    external?: boolean;
}) {
    const pathname = usePathname();
    const active = !external && isActive(pathname, href);
    const cls = `${baseCls} ${
        active ? "bg-accent text-accent-foreground" : "text-muted-foreground"
    }`;

    if (external) {
        return (
            <a href={href} target="_blank" rel="noopener noreferrer" className={cls}>
                {children}
            </a>
        );
    }
    return (
        <Link
            href={href}
            className={cls}
            aria-current={active ? "page" : undefined}
        >
            {children}
        </Link>
    );
}
